import {CircularProgress} from "@mui/material";
import React from "react";

import {useAuth} from "../hooks/useAuth";
import {useConfig} from "../hooks/useConfig";

function SSOLogin() {
  const { checkSession } = useAuth();
  const { apiHost } = useConfig();

  // ACH-2423: honor a return_to deep link (path+query+hash) set by the ACH 401
  // auto-reauth bounce so the user lands back where they were. Only a same-origin
  // absolute path (single leading '/') is accepted — guards against an open
  // redirect — otherwise fall back to the default landing.
  const returnTo = new URLSearchParams(window.location.search).get('return_to');
  const dest = returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/admin/contracts';

  checkSession(dest, apiHost);

  return <CircularProgress color="inherit" size={20} />;
}

export default SSOLogin;
